import React, { useEffect, useState } from 'react';
import { Button, TextField } from '@material-ui/core';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useSyles } from './styles';
import { login } from '../../../redux/auth/thunks';
import { useDispatch, useSelector } from 'react-redux';
import Loading from '../../common/Loading';
import { useNavigate } from 'react-router-dom';
import { GoogleLogin } from '@react-oauth/google';
import { Link } from 'react-router-dom';

const Login = () => {
  const classes = useSyles();
  const navigate = useNavigate();
  const dispatch = useDispatch<any>();
  const { token } = useSelector((state: any) => state.auth);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (token) {
      window.location.href = '/';
    }
  }, [token]);

  const initialValues = {
    user: '',
    password: '',
  };

  const goToRegister = () => {
    navigate(`/register`, { replace: true });
  };

  const validationSchema = yup.object({
    user: yup.string().required('Digite el nombre del usuario'),
    password: yup.string().required('Digite la contraseña'),
  });

  const formik = useFormik({
    initialValues,
    validationSchema: validationSchema,
    onSubmit: (values) => sendLogin({ values }),
  });

  const sendLogin = async ({
    values,
    isGoogleAuth,
    googleCredentialResponse,
  }: any) => {
    setLoading(true);
    try {
      if (isGoogleAuth) {
        await dispatch(
          login({ googleCredentialResponse, isGoogleAuth })
        ).unwrap();
        return;
      }

      const data = {
        country: process.env.REACT_APP_ENV_COUNTRY as string,
        email: values.user,
        password: values.password,
      };
      await dispatch(login({ data })).unwrap();
    } finally {
      setLoading(false);
    }
  };

  const onAction = () => formik?.handleSubmit();

  return (
    <div className={classes.container}>
      <div className={classes.logo}>
        <img
          alt='logo-keys'
          style={{ objectFit: 'contain' }}
          src={'/images/logo-keys.png'}
        />
      </div>

      <form className={classes.form} onSubmit={formik.handleSubmit}>
        <TextField
          id='form-user'
          label='Usuario'
          variant='outlined'
          name='user'
          onChange={formik.handleChange('user')}
          error={formik.touched.user && Boolean(formik.errors.user)}
          helperText={formik.errors.user as any}
        />

        <div className='w-full'>
          <TextField
            id='form-password'
            label='Clave'
            variant='outlined'
            name='password'
            type='password'
            className='w-full'
            onChange={formik.handleChange('password')}
            error={formik.touched.password && Boolean(formik.errors.password)}
            helperText={formik.errors.password as any}
          />

          <div className='flex justify-end mt-1'>
            <Link className='text-blue-500 text-xs' to='/forgot-password'>
              ¿Olvidaste tu contraseña?
            </Link>
          </div>
        </div>

        {!loading ? (
          <>
            <Button
              size='medium'
              color='secondary'
              variant='contained'
              onClick={onAction}
            >
              Iniciar sesión
            </Button>
            <Button onClick={goToRegister}>Crear cuenta</Button>
          </>
        ) : (
          <Loading height='50px' />
        )}

        <div className='relative flex  items-center'>
          <div className='flex-grow border-t border-gray-400'></div>
          <span className='flex-shrink mx-4 text-gray-400'>o</span>
          <div className='flex-grow border-t border-gray-400'></div>
        </div>

        <div className='mx-auto'>
          <GoogleLogin
            onSuccess={(googleCredentialResponse) => {
              sendLogin({
                isGoogleAuth: true,
                values: null,
                googleCredentialResponse,
              });
            }}
          />
        </div>
      </form>
    </div>
  );
};

export default Login;
